/**
 * 作者：bai.zhiming
 * 描述：左侧导航展开收起效果
 * 时间：2017-6-15
 */
"use strict";
angular.module("ulHeightMoudle", []).directive("ulHeight", ["$timeout", function($timeout) {
    return {
        restrict: 'A',
        replace: false,
        transclude: false,
        scope: {},
        link: function(scope, elem, attrs) {
            $timeout(function() {
                var height = 0;
                elem.find("li").each(function() {
                    height += $(this).height();
                });
                elem.height(height);
            },1000);
        }
    };
}]);